module.exports = __webpack_public_path__ + "img/img_brand16.c3902638.jpg";